import loadable from '@loadable/component'

export const LazyTwitterEmbed = loadable(() => import('./TwitterEmbed.web'))
